import { createSlice } from '@reduxjs/toolkit';

const treatmentSlice = createSlice({
    name: 'treatment',
    initialState: {
        loading: false,
        treatments: [],
        error: null,
        isCreated: false,
        isUpdated: false,
        isDeleted: false,
    },
    reducers: {
        treatmentRequest(state) {
            state.loading = true;
            state.error = null;
        },
        treatmentsSuccess(state, action) {
            state.loading = false;
            state.treatments = action.payload;
        },
        treatmentCreateSuccess(state, action) {
            state.loading = false;
            state.treatments = [...state.treatments, action.payload];
            state.isCreated = true;
        },
        treatmentUpdateSuccess(state, action) {
            state.loading = false;
            state.treatments = state.treatments.map(t =>
                t._id === action.payload._id ? action.payload : t
            );
            state.isUpdated = true;
        },
        treatmentDeleteSuccess(state, action) {
            state.loading = false;
            state.treatments = state.treatments.filter(t => t._id !== action.payload);
            state.isDeleted = true;
        },
        treatmentFail(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        clearTreatmentError(state) { state.error = null; },
        clearTreatmentCreated(state) { state.isCreated = false; },
        clearTreatmentUpdated(state) { state.isUpdated = false; },
        clearTreatmentDeleted(state) { state.isDeleted = false; },
    },
});

export const {
    treatmentRequest,
    treatmentsSuccess,
    treatmentCreateSuccess,
    treatmentUpdateSuccess,
    treatmentDeleteSuccess,
    treatmentFail,
    clearTreatmentError,
    clearTreatmentCreated,
    clearTreatmentUpdated,
    clearTreatmentDeleted,
} = treatmentSlice.actions;

export default treatmentSlice.reducer;

